var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"sub-title"},[_vm._v("欢迎体验")]),_c('div',{staticClass:"title"},[_vm._v(" 通用后台管理系统")]),_c('div',{staticClass:"desc"},[_vm._v(" 打造通用后台管理系统 ")])]),_c('div',{staticClass:"img"})])
}]

export { render, staticRenderFns }